<template>
  <div :class="outputObject.success ?  'GoogleDrive' : 'GoogleDrive__error' ">
    <div class="GoogleDrive__header">
      <span>Search Results</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && outputObject.success">
      <div v-if="isValidJson" class="GoogleDrive__body">
        <div>
          <div v-for="file in outputObject.Files" :key="file.id" style="margin-bottom: 10px; display: flex;">
            <div style="margin-right: 10px">
              <v-img :src="file.iconLink" width="20" height="20"/>
            </div>
            <div>
              <span v-if="!file.webViewLink">{{ file.name }}</span>
              <a v-if="file.webViewLink" :href="file.webViewLink" target="_blank" rel="noopener noreferrer">{{ file.name }}</a>
            </div>
          </div>
        </div>
        <json-viewer
            :expand-depth=0
            :value="outputObject"
            style="white-space: pre-line; border-radius: 15px; width: 100%"
        ></json-viewer>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="GoogleDrive__body">
        {{ outputObject }}
      </div>
    </div>
    <div v-if="extend && !outputObject.success">
      <div class="GoogleDrive__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import JsonViewer from 'vue-json-viewer';
import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 'google-get-folder-output',
  components: { JsonViewer },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      if(!this.isValidJson) {
        return this.output;
      }
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output)
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '../index';
</style>
